import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  OnDestroy,
} from '@angular/core';
import { HermesError } from '@kaligo/hermes';
import { Store } from '@ngrx/store';
import { DialogConfig } from '@rd/popup/dialog-config';
import { DialogRef } from '@rd/popup/dialog-ref';
import { LogoutUser } from '../../auth/store/actions/auth.actions';
import { CoreState } from '../../store/reducers';

@Component({
  selector: 'rd-core-auth-session-expired-dialog',
  templateUrl: './auth-session-expired-dialog.component.html',
  styleUrls: ['./auth-session-expired-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AuthSessionExpiredDialogComponent implements OnDestroy {
  @HostBinding('class.rd-core-auth-session-expired-dialog')
  componentClass = true;

  errorMessage = '';

  constructor(
    private dialogRef: DialogRef,
    private dialogConfig: DialogConfig<{ errors: HermesError[] }>,
    private store: Store<{ core: CoreState }>,
  ) {}

  ngOnDestroy(): void {
    this.logoutUser();
  }

  closeDialog(): void {
    this.dialogRef.close();
  }

  private logoutUser(): void {
    this.store.dispatch(new LogoutUser());
  }
}
